// reCAPTCHA v3 dels formularis públics. L'script de Google només es carrega
// quan s'envia un formulari (no a totes les pàgines). La clau pública surt de
// <meta id="recaptcha_key"> (app.blade.php); sense clau retorna '' i el
// backend tampoc el demana.
let carregant = null;

function claveRecaptcha() {
    const meta = document.getElementById('recaptcha_key');
    return meta ? meta.getAttribute('content') : '';
}

function carregarScript(clave) {
    if (window.grecaptcha && window.grecaptcha.execute) return Promise.resolve();
    if (carregant) return carregant;

    carregant = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(clave)}`;
        script.async = true;
        script.onload = () => window.grecaptcha.ready(resolve);
        script.onerror = () => {
            carregant = null;
            reject(new Error('No s\'ha pogut carregar reCAPTCHA'));
        };
        document.head.appendChild(script);
    });

    return carregant;
}

export async function tokenRecaptcha(accion = 'contacto') {
    const clave = claveRecaptcha();
    if (!clave) return '';

    try {
        await carregarScript(clave);
        return await window.grecaptcha.execute(clave, { action: accion });
    } catch (e) {
        return '';
    }
}
